<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.purchases.retrieveLoader">
      <v-boilerplate type="table-heading, list-item-two-line" />
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="table" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <v-row align="center" justify="start" no-gutters>
              <router-link :to="{ name: 'BillersBuiltInSettings' }" class="subtitle-1 routerLink font-weight-medium">Facturación incorporada</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <router-link class="subtitle-1 routerLink font-weight-medium" :to="{name: 'RetentionList'}">Facturas de compra</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <span class="subtitle-1 font-weight-medium d-inline-block text-truncate" :style="$vuetify.breakpoint.width < 1200 ? 'max-width: 350px;' : 'max-width: 500px;'">{{instance.document.name}} Nº {{instance.number}}</span>
            </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-1" @click="renderDocument('purchases', 'retentions', 'pdf')" outlined color="secondary" retain-focus-on-click><v-icon small left>mdi-file-document</v-icon>PDF</v-btn>

              <!-- more options -->
              <v-menu v-if="instance.status !== 'cancelled'" close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-1" v-bind="attrs" v-on="on" retain-focus-on-click outlined color="secondary">Más<v-icon right>mdi-chevron-down</v-icon></v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-5 py-1" @click="dialogCancellation=true" :ripple="false">
                    <v-list-item-title class="subtitle-2 red--text font-weight-medium"><v-icon color="red" small left>mdi-circle-off-outline</v-icon>Crear nota de crédito</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <!-- end more options -->
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <v-row class="mx-0 background" align="center">
            <v-col cols="2">
              <span class="d-block mb-1">Total</span>
              <span class="body-1 font-weight-medium mr-1">{{instance.total | currency(instance.currency)}}</span>
              <span>{{instance.currency}}</span>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="3" class="ml-2">
              <span class="d-block mb-1">Proveedor</span>
              <v-btn :to="{name:'SupplierRetrieveUpdate', params:{id: instance.supplier.id}}" height="20" text color="primary" retain-focus-on-click :ripple="false">
                <span class="d-inline-block text-truncate" style="max-width: 200px;">{{((instance || {}).supplier || {}).name}}</span>
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="2" class="ml-2">
              <span class="d-block mb-1">Fecha</span>
              <div class="font-weight-medium mt-1">{{instance.date | date}}</div>
            </v-col>
            <template v-if="instance.status === 'cancelled'">
              <v-divider class="my-2" vertical />
              <v-col cols="3" class="ml-2">
                  <v-chip class="mx-1" color="defaultGrey" text-color="secondary" small>Tiene nota de crédito<v-icon class="ml-1" x-small>mdi-close</v-icon></v-chip>
              </v-col>
            </template>
          </v-row>
          <v-divider />
          <v-row>
            <v-col class="pb-0" cols="12">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Información general</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="5">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Tipo de documento</v-list-item-title>
                  <v-list-item-subtitle>{{((instance || {}).document || {}).name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Número</v-list-item-title>
                  <v-list-item-subtitle>{{instance.number}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Tipo</v-list-item-title>
                  <v-list-item-subtitle>Retención</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Creado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.created | dateTime}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- SII management -->
      <v-card class="px-0 my-5" v-if="account.country.id == 'CL' && instance.document.has_local_format">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Gestión Servicio de Impuestos Internos</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" retain-focus-on-click outlined color="secondary">Opciones</v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-5 py-1" :href="instance.local_file" target="_blank" :ripple="false">
                    <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">Ver XML</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form-extended transparent py-5">
            <v-list-item>
              <v-list-item-title>Estado</v-list-item-title>
              <v-list-item-subtitle>
                <v-btn v-if="!instance.tax_agency.cl_status" @click="taxAgencyService('purchases', 'retentions', 'tax_agency_status')" :loading="taxAgencyLoader" text color="primary" :ripple="false">Actualizar estado</v-btn>
                <v-chip v-else-if="instance.tax_agency.cl_status.includes('Rechazado')" class="caption" color="defaultGrey" text-color="secondary" small>{{instance.tax_agency.cl_status}}<v-icon class="ml-1" x-small>mdi-close</v-icon></v-chip>
                <v-chip v-else color="lightBlue" text-color="primary" small>{{instance.tax_agency.cl_status}}<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="instance.tax_agency.cl_status_detail">
              <v-list-item-title>Detalle del estado</v-list-item-title>
              <v-list-item-subtitle>{{instance.tax_agency.cl_status_detail}}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>
                Track ID
                <v-tooltip v-if="!instance.tax_agency.cl_id" right transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="red">mdi-alert</v-icon>
                  </template>
                  <span>Es requerido enviar a la agencia fiscal</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle class="text-left">
                <span v-if="instance.tax_agency.cl_id">{{instance.tax_agency.cl_id}}</span>
                <span v-else><v-btn @click="taxAgencyService('purchases', 'retentions', 'tax_agency_send')" :loading="taxAgencyLoader" text color="primary" :ripple="false">Enviar a la agencia fiscal</v-btn></span>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
      <!-- end SII management -->

      <!-- cancellation -->
      <v-card class="px-0 my-5" v-if="instance.status === 'cancelled'">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Nota de crédito</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" retain-focus-on-click outlined color="secondary">Opciones</v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-5 py-1" :href="cancellation.local_file" target="_blank" :ripple="false">
                    <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">Ver XML</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row>
            <v-col cols="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Razón</v-list-item-title>
                  <v-list-item-subtitle>{{cancellation.note}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>ID</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-tooltip right transition="scale-transition">
                      <template v-slot:activator="{on}">
                        <v-btn class="font-weight-regular" @click="toClipboard(cancellation.id)" text color="secondary" v-on="on" :ripple="false">{{cancellation.id}}</v-btn>
                      </template>
                      <span>Copiar</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Creado por</v-list-item-title>
                  <v-list-item-subtitle>{{cancellation.user}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Creado el</v-list-item-title>
                  <v-list-item-subtitle>{{cancellation.created | dateTime}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Nota interna</v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-subtitle v-if="cancellation.internal_note">{{cancellation.internal_note}}</v-list-item-subtitle>
                  <v-list-item-subtitle class="font-italic text--disabled" v-else>Sin nota interna</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- end cancellation -->

      <v-card class="pa-0 my-5">
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Items</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Item</th>
                  <th class="text-right">Cantidad</th>
                  <th class="text-right">P. unitario</th>
                  <th class="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="d in instance.lines">
                  <tr :key="d.id">
                    <td>
                      <span class="body-2 text--secondary">{{d.name}}</span>
                      <span class="d-block">{{d.description}}</span>
                    </td>
                    <td class="text-right">{{d.quantity | currency(instance.currency)}}</td>
                    <td class="text-right">
                      <span class="text--secondary font-weight-medium">{{d.amount | currency(instance.currency)}}</span>
                    </td>
                    <td class="text-right">
                      <span class="body-2 text--secondary font-weight-medium">{{d.total | currency(instance.currency)}}</span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider />
          <!-- summary -->
          <v-row align="center" justify="end">
            <v-col cols="4">
              <v-list class="v-list-form pa-0 transparent">
                <v-list-item class="py-1">
                  <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Exento</v-list-item-title>
                  <v-list-item-subtitle class="text-right">{{instance.exempt | number}}</v-list-item-subtitle>
                </v-list-item>
                <template v-if="instance.document.has_taxes && instance.document.has_taxes_detail">
                  <v-list-item class="py-1">
                    <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Neto</v-list-item-title>
                    <v-list-item-subtitle class="text-right">{{instance.amount | number}}</v-list-item-subtitle>
                  </v-list-item>
                    <v-list-item class="py-1">
                    <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Descuento</v-list-item-title>
                    <v-list-item-subtitle class="text-right">{{instance.discount | number}} {{instance.discount_scheme}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-divider class="ml-4 my-3" />
                  <v-list-item class="py-1">
                    <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Impuestos ({{instance.tax_percent}}%)</v-list-item-title>
                    <v-list-item-subtitle class="text-right">{{instance.tax | number}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="py-1">
                    <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Retención ({{instance.tax_percent}}%)</v-list-item-title>
                    <v-list-item-subtitle class="text-right">{{instance.tax | number}}</v-list-item-subtitle>
                  </v-list-item>
                </template>
                <v-divider class="ml-4 my-3" />
                <v-list-item class="py-1">
                  <v-list-item-title class="text-left body-1 text--secondary font-weight-medium">Total</v-list-item-title>
                  <v-list-item-subtitle class="text-right body-1 text--secondary font-weight-medium">{{instance.total | currency(instance.currency)}} {{instance.currency}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <!-- end summary -->
        </v-card-text>
      </v-card>
    </v-col>

    <!-- modal pdf -->
    <v-dialog v-model="modalRender" v-if="instance.id" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">{{`PDF ${instance.document.name} Nº ${instance.number}`}}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn @click="modalRender=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row v-if="loaderRender">
            <v-col cols="12" class="py-0 ma-0">
              <v-skeleton-loader class="rounded-0" transition="fade-transition" type="table" />
            </v-col>
          </v-row>
          <v-row v-else-if="!loaderRender && !renderUrl">
            <v-col cols="12" class="py-16 text-center">
              <v-icon class="d-block" color="secondary" size="70">mdi-image-broken-variant</v-icon>
              <span class="d-block subtitle-1">PDF no disponible</span>
            </v-col>
          </v-row>
          <div id="render"></div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn :href="renderUrl" :download="`${instance.document.id}_N${instance.number}`" color="primary" dark>Descargar PDF</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end modal pdf -->

    <!-- dialog credit note -->
    <v-dialog v-model="dialogCancellation" width="700" persistent no-click-animation scrollable>
      <v-card class="pa-0">
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Crear nota de crédito</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogCancellation=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form transparent">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="mr-3 text--secondary font-weight-medium">Fecha</span>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <v-row class="mx-0">
                    <v-col cols="6">
                      <v-menu v-model="dateMenu" :close-on-content-click="false" offset-y transition="scale-transition" max-width="280px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="$v.newCancellation.date.$model" :error="$v.newCancellation.date.$error" v-bind="attrs" v-on="on" background-color="white" outlined single-line dense readonly hide-details>
                            <template v-slot:append>
                              <v-icon class="mr-3" size="20px" color="secondary">mdi-calendar</v-icon>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="$v.newCancellation.date.$model" no-title @input="dateMenu=false" :min="instance.date" type="date" locale="es-cl" width="280" color="blue">
                          <div class="mx-auto">
                            <v-btn color="primary" @click="() => {$v.newCancellation.date.$model = today}">Hoy</v-btn>
                            <v-btn class="ml-2" outlined @click="() => {$v.newCancellation.date.$model = ''}">Limpiar</v-btn>
                          </div>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="mr-3 text--secondary font-weight-medium">Razón de la anulación</span>
                  <v-tooltip right max-width="280px" transition="scale-transition">
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                    </template>
                    <span>Escribe una razón por la cual crearás la nota de crédito. Esto será visible para tu cliente.</span>
                  </v-tooltip>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <v-text-field v-model="$v.newCancellation.note.$model" :error="$v.newCancellation.note.$error" background-color="white" outlined hide-details required single-line dense maxlength="60" />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="mr-3 text--secondary font-weight-medium">Nota interna <v-chip color="defaultGrey" text-color="secondary" small>Opcional</v-chip></span>
                  <v-tooltip right max-width="280px" transition="scale-transition">
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                    </template>
                    <span>Utiliza este campo para proveer información adicional sobre esta nota de crédito. Esto no será visible para tu cliente.</span>
                  </v-tooltip>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <v-textarea v-model="$v.newCancellation.internal_note.$model" :error="$v.newCancellation.internal_note.$error" background-color="white" outlined hide-details required maxlength="512" />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogCancellation=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="createCancellation" :loading="loaderCancellation" color="primary">Crear nota de crédito</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog credit note -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'

import GenericViewMixin from '@/mixins/GenericViewMixin'
import RenderViewMixin from '@/mixins/RenderViewMixin'
import TaxAgencyViewMixin from '@/mixins/TaxAgencyViewMixin'

export default {
  mixins: [
    GenericViewMixin,
    TaxAgencyViewMixin,
    RenderViewMixin
  ],
  inject: ['theme'],
  components: {
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({
    cancellation: {},
    dateMenu: false,
    dialogCancellation: false,
    loaderCancellation: false,
    newCancellation: {
      retention: '',
      date: '',
      internal_note: '',
      note: ''
    }
  }),
  computed: mapState({
    instance: state => state.purchases.retentionsDetail
  }),
  created () {
    this.retrieve()
  },
  methods: {
    createCancellation () {
      this.$v.newCancellation.$touch()

      if (this.$v.newCancellation.$invalid) {
        return false
      }

      this.$dialog.warning({
        title: 'Crear nota de crédito',
        text: `
          <span class="d-block mb-4">Al continuar</span>
          <span class="d-block">1. La factura de compra será anulada en su totalidad</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'primary',
            text: 'Crear nota de crédito',
            handle: () => {
              this.loaderCancellation = true

              // assign current retention
              this.newCancellation.retention = this.$route.params.id

              this.$store.dispatch('purchases/CREATE', {
                resource: 'cancellations',
                payload: this.newCancellation,
                commitInstance: false
              })
              .then((d) => {
                // hide dialog
                this.dialogCancellation = false

                // reload
                this.retrieve()
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
              .finally(() => {
                this.loaderCancellation = false
              })
            }
          }
        ]
      })
    },
    retrieve () {
      this.$store.dispatch('purchases/RETRIEVE', {
        resource: 'retentions',
        id: this.$route.params.id
      })
      .then(() => {
        if (this.instance.status === 'cancelled') {
          this.retrieveCancellation()
        }
      })
    },
    retrieveCancellation () {
      this.$store.dispatch('purchases/LIST', {
        resource: 'cancellations',
        query: {
          retention: this.instance.id
        },
        setState: false
      })
      .then((d) => {
        this.cancellation = d.data.results[0]
      })
    }
  },
  validations: {
    newCancellation: {
      date: {
        required
      },
      internal_note: {
        maxLength: maxLength(1024)
      },
      note: {
        required,
        maxLength: maxLength(64)
      }
    }
  }
}
</script>